import React from 'react';
import { CalendarIcon, MapPinIcon, UsersIcon, TrendingUpIcon } from 'lucide-react';
export function HowItWorks() {
  return <section id="como-funciona" className="w-full bg-[#111111] py-20 px-4 sm:px-6 lg:px-8" data-id="element-151">
      <div className="max-w-7xl mx-auto" data-id="element-152">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-153">
          <h2 className="font-heading font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight" data-id="element-154">
            Reserva. Ven. Entrena. Repite.
          </h2>
          <div className="section-divider" data-id="element-155" />
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-14 relative" data-id="element-156">
          {/* Connecting line (desktop) */}
          <div className="hidden lg:block absolute top-8 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-[#C9A84C]/40 to-transparent" data-id="element-157" />

          {/* Step 1 */}
          <div className="flex flex-col items-center text-center relative" data-id="element-158">
            <div className="w-16 h-16 rounded-full bg-[#C9A84C] flex items-center justify-center mb-5 shadow-lg shadow-[#C9A84C]/30 relative z-10" data-id="element-159">
              <span className="font-heading font-bold text-black text-2xl" data-id="element-160">
                1
              </span>
            </div>
            <div className="w-10 h-10 bg-[#1a1a1a] border border-[#2a2a2a] rounded flex items-center justify-center mb-4" data-id="element-161">
              <CalendarIcon size={18} className="text-[#C9A84C]" data-id="element-162" />
            </div>
            <h3 className="font-heading font-bold text-white uppercase text-xl tracking-wide mb-2" data-id="element-163">
              Reserva
            </h3>
            <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-164">
              Elige día y hora en Calendly en menos de 30 segundos
            </p>
          </div>

          {/* Step 2 */}
          <div className="flex flex-col items-center text-center relative" data-id="element-165">
            <div className="w-16 h-16 rounded-full bg-[#C9A84C] flex items-center justify-center mb-5 shadow-lg shadow-[#C9A84C]/30 relative z-10" data-id="element-166">
              <span className="font-heading font-bold text-black text-2xl" data-id="element-167">
                2
              </span>
            </div>
            <div className="w-10 h-10 bg-[#1a1a1a] border border-[#2a2a2a] rounded flex items-center justify-center mb-4" data-id="element-168">
              <MapPinIcon size={18} className="text-[#C9A84C]" data-id="element-169" />
            </div>
            <h3 className="font-heading font-bold text-white uppercase text-xl tracking-wide mb-2" data-id="element-170">
              Llega
            </h3>
            <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-171">
              Llega 10 min antes. Te indicamos qué necesitas
            </p>
          </div>

          {/* Step 3 */}
          <div className="flex flex-col items-center text-center relative" data-id="element-172">
            <div className="w-16 h-16 rounded-full bg-[#C9A84C] flex items-center justify-center mb-5 shadow-lg shadow-[#C9A84C]/30 relative z-10" data-id="element-173">
              <span className="font-heading font-bold text-black text-2xl" data-id="element-174">
                3
              </span>
            </div>
            <div className="w-10 h-10 bg-[#1a1a1a] border border-[#2a2a2a] rounded flex items-center justify-center mb-4" data-id="element-175">
              <UsersIcon size={18} className="text-[#C9A84C]" data-id="element-176" />
            </div>
            <h3 className="font-heading font-bold text-white uppercase text-xl tracking-wide mb-2" data-id="element-177">
              Entrena
            </h3>
            <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-178">
              Entrenas con tu grupo y nivel. Técnica + físico desde el día 1
            </p>
          </div>

          {/* Step 4 */}
          <div className="flex flex-col items-center text-center relative" data-id="element-179">
            <div className="w-16 h-16 rounded-full bg-[#C9A84C] flex items-center justify-center mb-5 shadow-lg shadow-[#C9A84C]/30 relative z-10" data-id="element-180">
              <span className="font-heading font-bold text-black text-2xl" data-id="element-181">
                4
              </span>
            </div>
            <div className="w-10 h-10 bg-[#1a1a1a] border border-[#2a2a2a] rounded flex items-center justify-center mb-4" data-id="element-182">
              <TrendingUpIcon size={18} className="text-[#C9A84C]" data-id="element-183" />
            </div>
            <h3 className="font-heading font-bold text-white uppercase text-xl tracking-wide mb-2" data-id="element-184">
              Progresa
            </h3>
            <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-185">
              Te damos tu siguiente paso: frecuencia + plan personalizado
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-186">
          <a href="#precios" className="inline-block bg-[#C9A84C] hover:bg-[#E8C97A] text-black font-heading font-bold px-10 py-4 text-lg tracking-widest uppercase transition-all duration-200 shadow-lg shadow-[#C9A84C]/25 hover:shadow-[#C9A84C]/40 hover:scale-105" data-id="element-187">
            Reservar Clase Ahora
          </a>
        </div>
      </div>
    </section>;
}